import { render, staticRenderFns } from "./ReviewsTags.vue?vue&type=template&id=30d153c8&scoped=true&"
import script from "./ReviewsTags.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewsTags.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewsTags.vue?vue&type=style&index=0&id=30d153c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d153c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d153c8')) {
      api.createRecord('30d153c8', component.options)
    } else {
      api.reload('30d153c8', component.options)
    }
    module.hot.accept("./ReviewsTags.vue?vue&type=template&id=30d153c8&scoped=true&", function () {
      api.rerender('30d153c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewsTags.vue"
export default component.exports